/**
 * Pay app attachments — upload and delete (v4).
 */

import { getToken, resolveApiUrl } from './client'

export async function uploadPayAppAttachment(
  payAppId: number,
  file: File,
): Promise<{ id: number; filename: string; original_name: string }> {
  const fd = new FormData()
  fd.append('file', file)
  const token = getToken()
  const res = await fetch(resolveApiUrl(`/api/payapps/${payAppId}/attachments`), {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: fd,
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { error?: string }).error ?? 'Upload failed')
  }
  return res.json()
}

export async function deletePayAppAttachment(id: number): Promise<void> {
  const token = getToken()
  const res = await fetch(resolveApiUrl(`/api/attachments/${id}`), {
    method: 'DELETE',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { error?: string }).error ?? 'Delete failed')
  }
}
